import { render, staticRenderFns } from "./ProofOfFunds.vue?vue&type=template&id=2496f532"
import script from "./ProofOfFunds.vue?vue&type=script&lang=js"
export * from "./ProofOfFunds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports